import { withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PF2MCustomDragLayer from '~/components/PF2MCustomDragLayer';
import PF2MTabs from '~/components/PF2MTabs';
import AllocationsTab from './AllocationsTab';
import styles from './styles';

const PerforatorSchedules = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:Allocation') },
  ];

  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        hideSyncButton
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (
        <>
          <AllocationsTab />
          <PF2MCustomDragLayer />
        </>
      ) : null}
    </>
  );
};

export default withStyles(styles)(PerforatorSchedules);
